import React, { useState } from 'react'
import { Box, Button } from '@mui/material'
import { useProductWithPrimaryTreeForId } from '../../../api/tree.hooks'
import { copyToClipboard } from '../../../utility'
import { goToTree } from '../../tree/TreeActions'
import { ProductGroup } from './ProductGroup'
import { EditableTreeSwap } from './EditableTreeSwap'
import { VanityUrl } from '../../vanity/VanityUrl'

export function ManageMetadata({ productId }: { productId: number }) {
  return (
    <Box>
      <PrimaryUrl productId={productId} />
      <EditableUrl productId={productId} />
      <EditableTreeSwap productId={productId} />
      <ProductGroup productId={productId} />
      <Box sx={{ mt: 3, borderTop: 1, borderColor: 'divider', pt: 3 }}>
        <VanityUrl productId={productId} allowDelete={false} />
      </Box>
    </Box>
  )
}

function PrimaryUrl({ productId }: { productId: number }) {
  const product = useProductWithPrimaryTreeForId(productId)
  return <IdDisplay title={'Primary Tree'} ids={product?.primary_tree} />
}

function EditableUrl({ productId }: { productId: number }) {
  const product = useProductWithPrimaryTreeForId(productId)
  return <IdDisplay title={'Editable Tree'} ids={product?.editable_tree} />
}

function IdDisplay({
  title,
  ids,
}: {
  title: string
  ids?: { id: number; tree_id: string; version_id: string }
}) {
  const [showIds, setShowIds] = useState(false)

  if (!ids) {
    return (
      <Box>
        {title}: <strong>NONE</strong>
      </Box>
    )
  }

  const IdDisplay = () => {
    if (!showIds)
      return <Button onClick={() => setShowIds(true)}>Show IDs</Button>
    return <>{`${ids.tree_id}:${ids.version_id}`}</>
  }

  const doOpenTab = () => {
    goToTree({ treeId: ids.tree_id, versionId: ids.version_id })
  }

  return (
    <Box>
      <span>
        {title}: {ids.id}:
      </span>{' '}
      <IdDisplay />
      <Button
        onClick={() => copyToClipboard(`${ids.tree_id}:${ids.version_id}`)}
      >
        Copy Ids
      </Button>
      <Button onClick={doOpenTab}>Open</Button>
    </Box>
  )
}
